export default __webpack_public_path__ + "static/media/330_dummy2016-fashion01-de.f35a7de1.png";